<template>
  <div class="page-container">
    <div class="error-image"
         style="background-image: url(/img/502.png)"></div>
    <div class="text-content">
      <div class="text-one">错误代码：502</div>
      <div class="text-two">您可以进行以下操作：</div>
      <div class="text-two">1）刷新页面；</div>
      <div class="text-two">2）尝试关闭浏览器，重新进入；</div>
      <div class="text-link">刷新一下</div>
      <div class="text-two">若问题依然存在，请与服务器的管理员联系。</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
  },
  name: "unusual",
  inject: ['reload'],

  data () {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
    // 刷新
    refresh () {
      this.reload();
    },
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },
  created () {
  },
  mounted () {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../../assets/scss/variables";
@import "../../assets/scss/mixins";
.page-container {
  width: 100%;
  height: 100%;
  padding-top: 220px;
  background-color: $white;
  .error-image {
    width: 100%;
    height: 200px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .text-content {
    width: 100%;
    text-align: center;
  }
  .text-one {
    padding-top: 24px;
    padding-bottom: 12px;
    font-size: 20px;
    color: #2f2f4f;
    font-weight: bold;
  }
  .text-two {
    font-size: 14px;
    color: #697386;
  }
  .text-link {
    padding-top: 35px;
    padding-bottom: 40px;
    font-size: 16px;
    color: #0066ff;
  }
}
</style>